<ion-content>
	<div class="maintenance-page">
		<!-- Mobile Header -->
		<header class="maintenance-header maintenance-header--mobile">
			<img src="assets/images/ehe_health_logo.svg" alt="EHE Health" class="maintenance-logo" />
			<div class="maintenance-header__icons">
				<a href="tel:8886728172" class="maintenance-phone-icon" aria-label="Call 888.672.8172">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="22"
						height="22"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path
							d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.65 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
					</svg>
				</a>
				<span class="maintenance-book-icon" aria-label="Book Exam">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="22"
						height="22"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
						<line x1="16" y1="2" x2="16" y2="6" />
						<line x1="8" y1="2" x2="8" y2="6" />
						<line x1="3" y1="10" x2="21" y2="10" />
					</svg>
				</span>
			</div>
		</header>

		<!-- Desktop Header -->
		<header class="maintenance-header maintenance-header--desktop">
			<img src="assets/images/ehe_pulse_logo.svg" alt="EHE Health" class="maintenance-logo" />
			<div class="maintenance-header__actions">
				<div class="maintenance-header__btn-group">
					<a href="tel:8886728172" class="maintenance-phone-btn">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round">
							<path
								d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.65 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
						</svg>
						888. 672. 8172
					</a>
					<span class="maintenance-book-btn">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round">
							<rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
							<line x1="16" y1="2" x2="16" y2="6" />
							<line x1="8" y1="2" x2="8" y2="6" />
							<line x1="3" y1="10" x2="21" y2="10" />
						</svg>
						Book Exam
					</span>
				</div>
			</div>
		</header>

		<!-- Main Content -->
		<main class="maintenance-main">
			<h1 class="maintenance-title">We're Fine-Tuning Your Experience</h1>

			<div class="maintenance-schedule" *ngIf="maintenanceSchedule">
				Maintenance Schedule: {{ maintenanceSchedule }}
			</div>

			<div class="maintenance-body">
				<p>
					Stretching is essential to fitness. Scheduled maintenance also keeps MyEHE running smoothly! Fortunately, ours
					will be finished shortly and we can continue helping you.
				</p>
				<p>
					We apologize for the inconvenience. In the meantime, you can explore our
					<a href="https://www.ehe.health/blog">blog</a> for tips on healthier nutrition, exercise, and more.
				</p>
				<p>For immediate assistance, please call us at <a href="tel:8886728172">888.672.8172</a>.</p>
			</div>

			<div class="maintenance-actions">
				<a href="https://www.ehe.health/blog" class="btn-explore-blog">Explore our Blog</a>
				<button (click)="refreshPage()" class="btn-refresh">Refresh Page</button>
			</div>
		</main>

		<!-- Footer -->
		<footer class="maintenance-footer">
			<span>&copy; {{ currentYear }} EHE. All rights reserved.</span>
			<a routerLink="/terms">Terms and Conditions</a>
			<span class="maintenance-footer__sep">|</span>
			<a routerLink="/privacy-policy">Data Privacy Policy</a>
			<span class="maintenance-footer__sep">|</span>
			<a routerLink="/notice-of-privacy-practices">Notice of Privacy Practices</a>
			<span class="maintenance-footer__sep">|</span>
			<a href="#" (click)="openCookiePreferences($event)">Cookie Preferences</a>
		</footer>
	</div>
</ion-content>
